import http from './default.js'

export default class WotcApplicantService {

  static async getAllProviders() {    
    const wotcProviderConfig = `${process.env.REACT_APP_WOTC_APPLICANT_SERVICE}/v2/providers`
    return await http.get(wotcProviderConfig)
  }
  
  static async getWotcClient(client_id) {    
    const wotcClientConfig = `${process.env.REACT_APP_WOTC_APPLICANT_SERVICE}/v2/clients/${client_id}/configure`
    return await http.get(wotcClientConfig)
  }

  static async saveWotcConfig(client_id, wotcConfig) {
    let updatedObject = {}
    if (wotcConfig.active) {
      updatedObject = {
        ...wotcConfig,
        locations: [],
        organizationCode: wotcConfig.selectedOrganizationCode,
        providerName: wotcConfig.selectedProvider
      }
    } else {
      updatedObject = {
        ...wotcConfig
      }
    }
    
    const wotcClientConfig = `${process.env.REACT_APP_WOTC_APPLICANT_SERVICE}/v2/clients/${client_id}/configure`
    const response = await http.post(wotcClientConfig, updatedObject)
    return response
  }

  static async getWotcEditHistory(client_id) {
    const clientConfig = `${process.env.REACT_APP_WOTC_APPLICANT_SERVICE}/v2/clients/${client_id}/configure/history`
    const response = await http.get(clientConfig)
    return response
  }

  static async linkCredentials(target_client_id, source_client_id, force = false) {
    const url = `${process.env.REACT_APP_WOTC_APPLICANT_SERVICE}/v2/providers/adp/clients/${target_client_id}/link-credentials`
    const response = await http.post(url, { force, sourceClientId: source_client_id })
    return response
  }

  static async unlinkCredentials(target_client_id) {
    const url = `${process.env.REACT_APP_WOTC_APPLICANT_SERVICE}/v2/providers/adp/clients/${target_client_id}/link-credentials`
    const response = await http.delete(url)
    return response
  }

}